import { combineEpics } from 'redux-observable';
import ComputeCreateEpic from './ComputeCreateEpic';
import ComputeServicePrincipalEpic from '../components/ComputeCreateContainer/ComputeServicePrincipalEpic';
import ComputeServiceManagedIdentityEpic from '../components/ComputeCreateContainer/ComputeManagedIdentityEpic';
export const rootEpic = combineEpics(ComputeCreateEpic, ComputeServicePrincipalEpic, ComputeServiceManagedIdentityEpic);
export default rootEpic;

//# sourceMappingURL=epics.js.map
